import React from 'react'
import PropTypes from 'prop-types'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import FlexRow from '../../../../components/molecules/FlexRow'
import OpalHeading from '../../../../components/opal/OpalHeading'
import { useFormattingContext } from '../../../../components/organisms/FormattingProvider/FormattingContext'
import LinkCard from '../common/LinkCard'
import ThreadMenu, { useThreadMenu } from '../common/menu/ThreadMenu'
import LinkCardDots from '../common/LinkCardDots'

function SearchResult ({ result, onRename, onDelete }) {
  const { formatter } = useFormattingContext()

  const threadMenu = useThreadMenu(onRename, onDelete)

  return (
    <LinkCard to={`/denali-ai/chat/${result.threadId}`}>
      <FlexRow>
        <FlexColumn className='gap-sm flex-1'>
          <FlexRow>
            <OpalHeading className='font-serif font-size-md'>{result.name}</OpalHeading>
          </FlexRow>
          <FlexRow>
            <span className='font-sans font-size-xs'>Last Activity: {formatter(result.lastActivity, 'since')}</span>
          </FlexRow>
        </FlexColumn>
        <FlexColumn className='items-center justify-center'>
          <LinkCardDots onClick={threadMenu.handleMenuOpen} />
        </FlexColumn>
      </FlexRow>
      <ThreadMenu
        subject={result}
        menuAnchor={threadMenu.menuAnchor}
        onClose={threadMenu.handleMenuClose}
        onRename={threadMenu.handleRename}
        onDelete={threadMenu.handleDelete}
      />
    </LinkCard>
  )
}

SearchResult.propTypes = {
  result: PropTypes.shape({
    threadId: PropTypes.string,
    name: PropTypes.string,
    lastActivity: PropTypes.string,
    createdDate: PropTypes.string
  }),
  onRename: PropTypes.func,
  onDelete: PropTypes.func
}

export default SearchResult
